






























































import Vue from "vue";
import SvgIcon from "@/components/SvgIcon.vue";
import {
    DesignFile,
    DesignFileView,
    Simulation,
    SimulationDetail,
    UploadFile,
    ViewFile
} from "@/api/custom-simulation";
import { SimulationType, SimulationTypeText } from "@/constants/custom-simulation";

export default Vue.extend({
    components: { SvgIcon },
    computed: {
        list(): SimulationDetail[] {
            return this.$store.state.customSimulationModule.currentSimulationDetail.filter(
                v => ![SimulationType.homePage, SimulationType.loadingPage].includes(v.classType)
            );
        },
        selectedSimulationDetail(): SimulationDetail {
            return this.$store.state.customSimulationModule.selectedSimulationDetail;
        },
        currentSimulation(): Simulation {
            return this.$store.state.customSimulationModule.currentSimulation;
        },
        currentSimulationResource(): {
            designFile: DesignFile;
            uploadFile: UploadFile;
            viewFile: ViewFile;
            designFileViewList: DesignFileView[];
        } {
            return this.$store.state.customSimulationModule.currentSimulationResource;
        },
        isFold(): boolean {
            return this.$store.state.customSimulationModule.isFold;
        }
    },
    methods: {
        getTitle(type) {
            return SimulationTypeText[type];
        },
        getProgresText(sort) {
            if (sort === this.currentSimulation.step + 2) {
                return "进行中";
            }
            if (sort < this.currentSimulation.step + 2) {
                return "已完成";
            }
            return "";
        },
        selectDetail(item: SimulationDetail) {
            const api3d = this.$store.getters["modelViewModule/api3d"];
            api3d && api3d.removeAllMarkerDeviceInfo();
            this.$store.commit("customSimulationModule/setSelectedSimulationDetail", item);
            this.$store.dispatch("customSimulationModule/getSimulationResrouceDetail", {
                designFileId: item.designFileId
            });
        },
        toggleIsFold() {
            this.$store.commit("customSimulationModule/setIsFold", !this.isFold);
        }
    }
});
